export const getRessources = (path, file) => {
    return require(`@/assets/${path}/${file}`);
}